type Listener<T> = (state: T) => void;

export class Store<T extends object> {
  private state: T;
  private readonly initialState: T;
  private listeners: Set<Listener<T>> = new Set();

  constructor(initialState: T) {
    this.initialState = structuredClone(initialState);
    this.state = structuredClone(initialState);
  }

  getState(): T {
    return structuredClone(this.state);
  }

  setState(partial: Partial<T>): void {
    const prevState = this.state;
    const nextState = { ...this.state, ...partial };

    // Check if there's an actual change
    const hasChanged = Object.keys(partial).some(
      (key) => prevState[key as keyof T] !== partial[key as keyof T]
    );

    if (!hasChanged) return;

    this.state = nextState;
    this.listeners.forEach((listener) => listener(this.getState()));
  }

  subscribe(listener: Listener<T>): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  reset(): void {
    const prevState = this.state;
    this.state = structuredClone(this.initialState);

    // Check if there's an actual change
    const hasChanged = Object.keys(this.state).some(
      (key) => prevState[key as keyof T] !== this.state[key as keyof T]
    );

    if (hasChanged) {
      this.listeners.forEach((listener) => listener(this.getState()));
    }
  }
}
